import * as Yup from "yup"
import { ArticlePublishInfo, KnowledgeBaseArticlePublishType } from "../../models/knowledgeBase/knowledgeBasePublish"

const tNamespace = "knowledgeBase:publish."

const publishOrUnpublishTest = (field: string) =>
    Yup.number().test({
        name: "oneOfPublishOrUnpublish",
        message: `${tNamespace}empty-dates`,
        test: function (value) {
            const otherField = field === "PublishDate" ? "UnpublishDate" : "PublishDate"
            const otherValue = this.parent[otherField]

            return (value && !otherValue) || (!value && otherValue) || (value && otherValue)
        }
    })

const validateUnpublishDate = Yup.number().test({
    name: "unpublishDateLessThanPublishDate",
    message: `${tNamespace}wrong-unpublish-date`,
    test: function (value) {
        const unpublishDate = new Date(value)
        const publishDate = new Date(this.parent.PublishDate)
        unpublishDate.setSeconds(0, 0)
        publishDate.setSeconds(0, 0)

        return !value || unpublishDate > publishDate
    }
})

export const getArticlePublishFormValidationSchema = () =>
    Yup.object<ArticlePublishInfo>().shape({
        PublishDate: Yup.number().when("Type", {
            is: KnowledgeBaseArticlePublishType.Timeout,
            then: publishOrUnpublishTest("PublishDate").test(
                "smallDate",
                `${tNamespace}small-date`,
                value => !value || value >= Date.now()
            ),
            otherwise: Yup.number().nullable()
        }),
        UnpublishDate: Yup.number().when("Type", {
            is: KnowledgeBaseArticlePublishType.Timeout,
            then: publishOrUnpublishTest("UnpublishDate")
                .concat(validateUnpublishDate)
                .test("smallDate", `${tNamespace}small-date`, value => !value || value >= Date.now()),
            otherwise: Yup.number().nullable()
        })
    })
